/* eslint-disable prettier/prettier */
import { saveAs } from "file-saver";
import { payments } from "./payments";
import { matters } from "./matters";
import { expenses } from "./expenses";
import * as Excel from "exceljs";

export const applyRange = (sheet, range, attribute, value) => {
    const from = range.split(":")[0];
    const to = range.split(":")[1];

    const fromsplit = from.match(/(\d+|[^\d]+)/g).join("|");
    const tosplit = to.match(/(\d+|[^\d]+)/g).join("|");

    const fromA = fromsplit.split("|")[0];
    const fromN = fromsplit.split("|")[1];
    const toA = tosplit.split("|")[0];
    const toN = tosplit.split("|")[1];

    const toAN = colToNumber(toA);
    const fromAN = colToNumber(fromA);

    var i;
    var a;

    for (i = fromN; i <= toN; i++) {
        for (a = fromAN; a <= toAN; a++) {
            const c = sheet.getCell(numberToCol(a) + i);
            c[attribute] = value;
        }
    }
};

// Given Column to Number
function colToNumber(str) {
    let num = 0;
    let i = 0;
    while (i < str.length) {
        num = str[i].charCodeAt(0) - 64 + num * 26;
        i++;
    }
    return num;
}

//Given Number to Column name
function numberToCol(num) {
    let str = "",
        q,
        r;
    while (num > 0) {
        q = (num - 1) / 26;
        r = (num - 1) % 26;
        num = Math.floor(q);
        str = String.fromCharCode(65 + r) + str;
    }
    return str;
}

const EXCEL_EXTENSION = ".xlsx";

// Persisted expense/matter fields arrive from DynamoDB as strings using either a
// comma or a dot decimal separator, but can also come back as real numbers or be
// missing entirely. Calling .replace() on those last two throws and, because
// expenses.js runs outside any try/catch, that aborts the whole report for the
// attorney. Normalise here instead.
export const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;

    const parsed = parseFloat(String(value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
};

// `${attorney}_${new Date()}` produced names containing ":" and "()" — illegal on
// Windows — and collided for two runs in the same second.
const buildFileName = (attorney) => {
    const safeName = String(attorney).replace(/[\\/:*?"<>|]/g, "-").trim() || "report";
    const stamp = new Date().toISOString().slice(0, 19).replace("T", "_").replace(/:/g, "-");

    return `${safeName}_${stamp}${EXCEL_EXTENSION}`;
};

export const createReport = async (
    attorney, data, mattersData, persistedData,
    clioActivitiesKeyed, clioActivitiesAttorneyMatters, grefs, customTab
) => {
    const workbook = new Excel.Workbook();
    const paymentSheet = workbook.addWorksheet("Payments");
    payments(paymentSheet, data, attorney, mattersData, persistedData,
        clioActivitiesKeyed, clioActivitiesAttorneyMatters, grefs, customTab);

    const mattersSheet = workbook.addWorksheet("Matters");
    matters(mattersSheet, data, attorney, mattersData, persistedData,
        clioActivitiesAttorneyMatters);

    const expensesSheet = workbook.addWorksheet("Expenses");
    expenses(expensesSheet, attorney, persistedData, grefs);

    const buffer = await workbook.xlsx.writeBuffer();
    const filetype = "application/vnd.ms-excel;charset=utf-8";
    const blob = new Blob([buffer], { type: filetype });
    saveAs(blob, buildFileName(attorney));
};

export const subtractMonths = (date, months) => {
    date.setMonth(date.getMonth() - months);
    return date;
};
